var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "paper-container" }, [
    false
      ? _c(
          "div",
          {
            staticClass: "go-back",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("返回 ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "paper-detail" }, [
      _c("div", { staticClass: "paper-title" }, [
        _c("span", { staticClass: "paper-bg" }, [_vm._v("项目")]),
        _c("div", { staticClass: "paper-title-style" }, [
          _vm._v(_vm._s(_vm.projectData.title)),
        ]),
      ]),
      _c("div", {
        staticStyle: {
          width: "100%",
          "border-bottom": "1px dashed #e8eaee",
          "margin-top": "20px",
          "margin-bottom": "20px",
        },
      }),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("项目编号：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(_vm.projectData.id == null ? "-" : _vm.projectData.id) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("项目类别：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.typeFirst === null
                    ? _vm.projectData.typeSecondary === null
                      ? _vm.projectData.typeSecondary === null
                        ? "-"
                        : _vm.projectData.typeSecondary === null
                      : _vm.projectData.typeSecondary
                    : _vm.projectData.typeFirst
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticStyle: { display: "flex", width: "50%" } }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("项目负责人：")]),
          _vm.projectData.leaderItem
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "margin-right": "11px",
                    "align-items": "center",
                    cursor: "pointer",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goPersonalDetails(
                        _vm.projectData.leaderItem.id
                      )
                    },
                  },
                },
                [
                  _c("el-avatar", {
                    staticClass: "avatar",
                    attrs: { size: 18, src: _vm.projectData.leaderItem.avatar },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "textContent",
                      staticStyle: { "margin-left": "6px", color: "#2e1f88" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.projectData.leaderItem.scholarName) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c("div", [_vm._v("-")]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [
            _vm._v("项目金额（万元）："),
          ]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.fund == null ? "-" : _vm.projectData.fund
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("所属机构：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.org == null ? "-" : _vm.projectData.org
                ) +
                "； "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("所属学部：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.department == null
                    ? "-"
                    : _vm.projectData.department
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex", "margin-top": "8px" } }, [
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("批准年份：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.startYear == null
                    ? ""
                    : _vm.projectData.startYear
                ) +
                " "
            ),
            _vm.projectData.endYear !== null
              ? _c("span", [_vm._v("-")])
              : _vm._e(),
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.endYear == null ? "" : _vm.projectData.endYear
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "text-title" }, [
          _c("span", { staticClass: "textSpan" }, [_vm._v("学科分类：")]),
          _c("div", { staticClass: "textContent" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.projectData.disciplineFirst == null
                    ? "-"
                    : _vm.projectData.disciplineFirst
                ) +
                " "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }